import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { ManagementDraftPackageModel, ManagementPackageModel } from '@data-layer/models/management';
import { LCLShipmentModel, PackageModel } from '@data-layer/models/lcl';

@Injectable({
  providedIn: 'root',
})
export class PackagesRepository {
  constructor(private apiService: ApiService) {}

  public createDraftManagement(
    shipmentId: number,
    model: ManagementDraftPackageModel[],
    isShowLoader?: boolean,
  ): Observable<ManagementDraftPackageModel> {
    return this.apiService.post<any>(`${environment.url.freight.shipmentsManagement}/${shipmentId}/draft-packages`, model, null, {
      isShowLoader,
    });
  }

  public createConfirmedManagement(
    shipmentId: number,
    model: Array<ManagementPackageModel | ManagementDraftPackageModel>,
    isShowLoader?: boolean,
  ): Observable<ManagementPackageModel> {
    return this.apiService.post<any>(`${environment.url.freight.shipmentsManagement}/${shipmentId}/confirmed-packages`, model, null, {
      isShowLoader,
    });
  }

  public updateDraftManagement(shipmentId: number, model: ManagementDraftPackageModel[], isShowLoader?: boolean): Observable<any> {
    return this.apiService.put<any>(`${environment.url.freight.shipmentsManagement}/${shipmentId}/draft-packages`, model, null, {
      isShowLoader,
    });
  }

  public updatePackagesUser(shipmentId: number, model: PackageModel[], isShowLoader?: boolean): Observable<LCLShipmentModel> {
    return this.apiService.put<any>(`${environment.url.freight.shipments}/${shipmentId}/packages`, model, null, {
      isShowLoader,
    });
  }
}
